import SkeletonProducts from './SkeletonProducts';

export default SkeletonProducts;
